export interface iCheckoutOrderReview {
  purchaseOrderNumber?: string;
  requestedDeliveryDate?: string;
  deliveryAddress?: iShippingAddressArray;
}

import { Component, OnInit } from '@angular/core';
import { iShippingAddressArray } from '../../cart/cart.model';
import { CartService } from '../../cart/cart.service';
@Component({
  selector: 'app-order-review',
  templateUrl: './order-review.component.html',
  styleUrls: ['./order-review.component.scss'],
})
export class OrderReviewComponent implements OnInit {
  // cart: Observable<Cart>;
  shiptoObj: iCheckoutOrderReview = {};
  cartData: any;
  constructor(private cartService: CartService) {
    this.cartService.$orderSimulateResponse.subscribe((resp) => {
      if (resp) {
        this.cartData = resp;
        let delivery_date = [
          resp?.requestedDeliveryDate?.slice(6, 8),
          '-',
          resp?.requestedDeliveryDate?.slice(4, 6),
          '-',
          resp?.requestedDeliveryDate?.slice(0, 4),
        ].join('');
        this.shiptoObj = {
          deliveryAddress: resp.deliveryAddress,
          purchaseOrderNumber: resp?.purchaseOrderNumber,
          requestedDeliveryDate: delivery_date,
        };
      }
    });
  }

  ngOnInit(): void {}
}
